module.exports = __webpack_public_path__ + "static/play-store-dark-50afc9fbac90748e266a880b1f7bbd8d.svg";